module.exports = "<a href=# class=\"q-btn {%-displayClass%} {%-activeClass%}\" data-qb-key=\"{%-value%}\"> {%-display%} </a>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/report/lookup/html/dateRangeOption.html
// module id = 1397
// module chunks = 1